export default __webpack_public_path__ + "static/media/144-print.6cd1f913.svg";